import { render, staticRenderFns } from "./activateUser.vue?vue&type=template&id=5f5fd6a6"
import script from "./activateUser.vue?vue&type=script&lang=js"
export * from "./activateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports